window.$InnovateCarousels = []

const MOBILE_BREAKPOINT = 768

const desktopMediaQuery = window.matchMedia(`(min-width: ${MOBILE_BREAKPOINT}px)`)

const debounce = (func, wait, immediate) => {
    let timeout

    return function() {
        const context = this
        const args = arguments

        const later = () => {
            timeout = null
            if (!immediate) func.apply(context, args)
        }

        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)

        if (callNow) func.apply(context, args)
    }

}

const createCarousels = () => {
    const IS_MOBILE = window.innerWidth < MOBILE_BREAKPOINT
    const SELECTOR = IS_MOBILE ? 'mobile' : 'desktop'

    window.$InnovateCarousels.forEach(carousel => carousel.destroy())

    const [...carousels] = document.querySelectorAll(`.ig-${SELECTOR}-carousel`)

    carousels.forEach(carousel => {
        const scriptData = carousel
            .closest(`[data-section-id=${carousel.dataset.parentId}`)
            .querySelector(`[data-${SELECTOR}-carousel-settings]`)
        const settings = JSON.parse(scriptData.textContent)
        const carouselInstance = new Flickity(carousel, settings)

        window.$InnovateCarousels.push(carouselInstance)
    })
}

const debouncedCreateCarousels = debounce(createCarousels, 500)

document.addEventListener('DOMContentLoaded', createCarousels.bind(this))
desktopMediaQuery.addEventListener('change', debouncedCreateCarousels)
